import type { WsStatus } from '@shared/types'

import { create } from 'zustand'

interface WsConnectionState {
  status: WsStatus
  lastPongAt: number | null
  setStatus: (s: WsStatus) => void
  setPongTime: (t: number) => void
}

export const useWsConnectionStore = create<WsConnectionState>((set) => ({
  status: 'disconnected',
  lastPongAt: null,
  setStatus: (status) => set({ status }),
  setPongTime: (t) => set({ lastPongAt: t }),
}))
